import { useIntl } from '@capsicum/common';

export const useNCWSendNoAssetsDrawer = () => {
	const { $t } = useIntl();

	const title = $t('ncWallet.send.noAssetDrawer.title');
	const description = $t('ncWallet.send.noAssetDrawer.description');
	const closeBtnText = $t('ncWallet.send.noAssetDrawer.buttonText');

	return {
		intlText: {
			closeBtnText,
			description,
			title
		}
	};
};
